import $ from 'jquery';

var $searchWrap = $('.navbar-search-wrap');
var $btnHideSearch = $('#btnHideNavbarSearch');

$btnHideSearch.on('click', function () {
    $searchWrap.addClass('d-none');
});

$(document).on('click', 'button[data-bs-toggle="navbar-search"]', function () {
    $searchWrap.removeClass('d-none');
    $searchWrap.find('input').val('').focus();
});
